import { Stack } from 'design-system'
import { FC } from 'react'

import { ExpandableSection } from './expandable-section'

interface ArchivedBoardStudentViewProps {
  networkTitle: string
}

export const ArchivedBoardStudentView: FC<ArchivedBoardStudentViewProps> = ({
  networkTitle
}) => (
  <div className="py-4 text-left text-slate-500">
    The community you&apos;re trying to reach has been archived and is no longer
    accessible here. Please contact the{' '}
    <span className="font-semibold">Community Owner</span> or a{' '}
    <span className="font-semibold">Yellowdig Administrator</span> for{' '}
    <span className="font-semibold">{networkTitle}</span> to obtain additional
    information or if you believe there may have been an error.
    <Stack gap={3}>
      <ExpandableSection message="What happens to the content and points earned?">
        All information and data in this community that is associated to your
        profile, content and earning points accumuated in this community is
        archived (not deleted) and no longer accessible. If this was an
        LTI-integrated community, this change does not affect the score in your
        Learning Management System (LMS).
      </ExpandableSection>
      <ExpandableSection message="What happens to my content?">
        The content you created in this community is archived (not deleted) and
        is no longer accessible.
      </ExpandableSection>
      <ExpandableSection message="Who should I contact?">
        If you have any questions regarding this community, please contact the
        Community Owner or a Yellowdig Administrator for {networkTitle}.
      </ExpandableSection>
    </Stack>
  </div>
)
